import { supabase } from "../lib/supabaseClient";

/**
 * Safely deletes a user account and all related data
 * @param {string} userId - The UUID of the user to delete
 * @returns {Promise<Object>} Result object with success status and details
 */
export const deleteUserAccount = async (userId) => {
  try {
    // Call the database function to delete the account
    const { data, error } = await supabase.rpc('delete_user_account', {
      user_id_to_delete: userId
    });

    if (error) {
      console.error('Error calling delete_user_account:', error);
      throw new Error(error.message || 'Failed to delete account');
    }

    // Check if the function returned an error
    if (data && !data.success) {
      throw new Error(data.error || 'Failed to delete account');
    }

    console.log('Account deletion successful:', data);
    return {
      success: true,
      data: data,
      message: data.message || 'Account deleted successfully'
    };
  } catch (error) {
    console.error('Account deletion error:', error);
    return {
      success: false,
      error: error.message || 'An unexpected error occurred'
    };
  }
};
